<template>
  <div class="pagesign">
    <XR-head titleText="我的签到" :rightShow="false"></XR-head>    
    <mu-list v-if="!loaded" v-for="signItem in signList" :key="signItem.GuidId">
      <mu-list-item :title="signItem.date"  >
        <!--
        <mu-flat-button :label="signItem.isToday?'签到':'补签'" style="color:red;" slot="right" @click="open(signItem.isToday, signItem.date)" v-if="!signItem.signState" />
        -->
        <mu-flat-button label="签到" style="color:red;" slot="right" @click="open(signItem.isToday, signItem.date)" v-if="!signItem.signState && signItem.isToday" />

        <mu-card-text slot="default" style="font-size:14px;"  v-if="!signItem.signState">未领取</mu-card-text>
        <mu-card-text slot="default" style="color:red; font-size:14px;"  v-if="signItem.signState">100BAW</mu-card-text>
        <mu-card-text slot="right"  v-if="signItem.signState">{{signItem.signStateText}}</mu-card-text>
      </mu-list-item>      
    </mu-list>
    <mu-dialog :open="dialog" title="提醒" @close="close">
      {{noticeText}}
      <mu-flat-button slot="actions" @click="close" primary label="取消"/>
      <mu-flat-button slot="actions" primary @click="buqian" label="确定"/>
    </mu-dialog>
    <mu-dialog :open="successDialog" title="签到成功" @close="closeDialog">
      <img src="/static/signin/success.jpg" style="width:39.95vw;height:39.3vw;" @click="closeDialog">
    </mu-dialog>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import pointconfig from '../../util/pointconfigCache'
export default {
  data(){
    return {
	  pointInfo: pointconfig.getPointconfig(),
      successDialog:false,
      dialog: false,
      loaded: true,
      signList:[],
      queryInfo:{
        pageIndex:1,
        pageSize:31,
        bz:'month'
      },
      noticeText:'',
      buqianCount:0,
      buqianDate:''
    }
  },
  mounted(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.getPointInfo()
    this.$refs.XRtoast.load()
    this.getBuqianInfo()
    this.getSignList()
  },
  methods:{
    closeDialog(){
      this.successDialog = false;
    },
    getPointInfo: function() {
      const ths = this;
      this.$post("/Shop/IntegralServer/GetPointSetParam")
      .then(function(res) {
        if (res.IsSuccess) {
		  ths.pointInfo = res.Data;
          pointconfig.addPointconfig(res.Data)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getBuqianInfo(){      
      var ths = this
      this.loaded= true
      ths.$post(
        "/Shop/UserServer/GetMendSignInfo"
      ).then(function(res) {
        ths.loaded= false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.buqianCount = res.Data.memdintegral
        }
      });
    },
    getSignList(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetMemberSignTracePage",
        JSON.stringify(this.queryInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.loaded=false   
          var dateObj = new Date()
          var today = dateObj.getDate()
          var month = dateObj.getMonth()+1
          if(month<10){
            month = '0'+month
          }
          month = dateObj.getFullYear()+'-'+ month +'-'
          var dataList = []

          var award_desc = "";
          for (var i = today; i >= 1; i--) {
            var z = 0;
            var isCz = 0;
            var day = i;
            var date = month;
            if(i < 10)
            {
                day = "0"+i;
            } 
            var ismend=false;
            award_desc = "";
            if (res.Data.List != null) {
              $.each(res.Data.List, function (k, l) { 
                if (i == l.signdateday) {
                  isCz = 1;
                  ismend=l.ismend;
                  z = 1;
                  date = l.signdatename;
                  day = l.signdatenameHour; 
                  if (l.money > 0) {
                      award_desc += l.money + '金币 ';
                  }
                  if (l.integral > 0) {
                      award_desc += l.integral + ths.pointInfo.PointName + ' ';
                  }
                } else if ((k + 1) == res.Data.Rows && z == 0) {
                  isCz = 0;
                }
              });
            } 
            var json = {}
            if (isCz == 1) {
              json.date = date
              json.award_desc = award_desc
              json.signState = true
              if(ismend){
                json.signStateText = "已补签"
              }else{
                json.signStateText = "已签到"
              }
            } else {
              
              json.date = month + day
              json.award_desc = '未领取'
              json.signState = false
              json.signStateText = ''

              // 今天
              if (i == today) {
                json.isToday = true
              } else {
                json.isToday = false
              }
            }

            dataList.push(json)
          }

          ths.signList = dataList
          ths.$refs.XRtoast.hide()
        }
      });
    },
    open (type, date) {
      if(!type){
        this.buqianDate = date
        this.noticeText = "补签需要消耗"+ this.buqianCount+"个" + "BAW" + "，是否继续？"
        this.dialog = true
      }
      else{
        this.signin(date)
      }
    },
    close () {
      this.buqianDate=''
      this.dialog = false
    },   
    buqian(){
      this.signin(this.buqianDate)
    }, 
    signin(date){    
      const ths = this;
      this.$post("/Shop/UserServer/MemberSignin" , {SignDate: date})
      .then(function(res) {
        //ths.close()
        if (res.IsSuccess) {
          ths.successDialog = true;
          //ths.$refs.XRtoast.success('签到成功',true);
          //ths.getBuqianInfo()
          ths.getSignList()
        }else{        
          ths.$refs.XRtoast.failed(res.Msg,true);
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }
  }
}
</script>

<style>
.pagesign{
  background: white;
  overflow-x: hidden;
  overflow-y: scroll;
}
.pagesign .mu-list .mu-flat-button-wrapper{
  background: red;
  color: #fff;
  width: 50px;
  height: 80%;
}
.pagesign .mu-flat-button-label{
  padding: 0px;
}
.pagesign .mu-list{
  border-bottom: 1px solid #f6f6f6;
}
.pagesign .mu-flat-button{
  min-width: 0;
}
.pagesign .mu-item-right{
  width: 50px;
}
.pagesign .mu-item{
  padding: 0px 16px;
}
.pagesign .mu-card-text{
  padding: 0px;
  width: 100%;
}
.pagesign .mu-item-content{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sign.vue